import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

// Shared GTM/GA4 instance. Kept outside InternalLayout so non-React modules
// (conversionEvents) can push to the same dataLayer the AnalyticsProvider uses.
const analytics = process.env.NEXT_PUBLIC_ENABLE_THIRD_PARTIES === 'true'
  ? Analytics({
    app: 'shapo',
    plugins: [
      googleTagManager({
        containerId: 'GTM-TZBSG5N5',
      }),
    ],
  })
  : {
    track: () => {},
    page: () => {},
    identify: () => {},
  };

export default analytics;
